export default __webpack_public_path__ + "static/media/plane1.e73b9a9c.jpg";